import type { ServantDefinition } from "./types.js";

export const DEFAULT_SERVANT_ID = "hourglass";

export const SERVANTS: readonly ServantDefinition[] = [
  {
    id: "apprentice",
    name: "新人",
    nameKey: "servant.apprentice.name",
    title: "夢の意味を探す者",
    titleKey: "servant.apprentice.title",
    art: "../../assets/story/characters/protagonist-v1.png",
    artId: "servant.apprentice",
    storyOnly: true,
    devotion: {
      id: "gentle-reframing",
      name: "読み替え",
      nameKey: "devotion.gentleReframing.name",
      effect: "discover",
      targetType: "object",
      grantedCardId: "red_ball",
      text: "夢1つの記憶をたどり、《赤いボール》を手札に加える。",
      textKey: "devotion.gentleReframing.text",
    },
  },
  {
    id: "hourglass",
    name: "《砂時計》",
    nameKey: "servant.hourglass.name",
    title: "ひとときを預かり、手放す者",
    titleKey: "servant.hourglass.title",
    art: "../../assets/story/characters/protagonist-hourglass-standing-v1.png",
    artId: "servant.hourglass",
    devotion: {
      id: "hold-one-hour",
      name: "一刻あずかる",
      nameKey: "devotion.holdOneHour.name",
      effect: "suspend",
      targetType: "object",
      text: "夢1つを次の時間まで預かる。その間は影響も時間経過も受けず、元のマスへ戻る。",
      textKey: "devotion.holdOneHour.text",
    },
  },
  {
    id: "flint",
    name: "《火打石》",
    nameKey: "servant.flint.name",
    title: "始まりの火花を落とす者",
    titleKey: "servant.flint.title",
    art: "../../assets/story/chapters/chapter-01/characters/flint-standing-v1.png",
    artId: "servant.flint",
    devotion: {
      id: "kindling-spark",
      name: "口火を切る",
      nameKey: "devotion.kindlingSpark.name",
      effect: "ignite",
      targetType: "object",
      text: "夢1つの影響を、この時間だけ符号方向へ2強め、絶対値4までにする。倍率効果はその後に適用する。",
      textKey: "devotion.kindlingSpark.text",
    },
  },
  {
    id: "ewer",
    name: "《水瓶》",
    nameKey: "servant.ewer.name",
    title: "満ちるところまで注ぐ者",
    titleKey: "servant.ewer.title",
    art: "../../assets/story/characters/ewer-standing-v1.png",
    artId: "servant.ewer",
    devotion: {
      id: "measured-pouring",
      name: "満たす一杯",
      nameKey: "devotion.measuredPouring.name",
      effect: "comfort",
      targetType: "player",
      text: "ご主人1人の幸福度を理想値15の方向へ必ず3動かす。次の時間、そのご主人の注目を固定する。",
      textKey: "devotion.measuredPouring.text",
    },
  },
  {
    id: "projector",
    name: "《映写機》",
    nameKey: "servant.projector.name",
    title: "わずかな違いを繰り返す者",
    titleKey: "servant.projector.title",
    art: "../../assets/story/characters/projector-standing-v1.png",
    artId: "servant.projector",
    devotion: {
      id: "repeat-frame",
      name: "もう一度",
      nameKey: "devotion.repeatFrame.name",
      effect: "replay",
      targetType: "replay",
      text: "直前の時間に自分が使ったカードを、演出力を使わず対象を選び直して再演する。",
      textKey: "devotion.repeatFrame.text",
    },
  },
  {
    id: "frame",
    name: "《額縁》",
    nameKey: "servant.frame.name",
    title: "見せたい構図を切り出す者",
    titleKey: "servant.frame.title",
    art: "../../assets/story/characters/frame-standing-v1.png",
    artId: "servant.frame",
    devotion: {
      id: "hold-in-frame",
      name: "一枚に収める",
      nameKey: "devotion.holdInFrame.name",
      effect: "frame",
      targetType: "object",
      text: "この時間、その夢があるレーンでは選んだ夢だけを幸福度へ反映する。",
      textKey: "devotion.holdInFrame.text",
    },
  },
  {
    id: "pin",
    name: "《標本針》",
    nameKey: "servant.pin.name",
    title: "失われる形へ札を付ける者",
    titleKey: "servant.pin.title",
    art: "../../assets/story/characters/pin-standing-v1.png",
    artId: "servant.pin",
    devotion: {
      id: "specimen-stitch",
      name: "標本にする",
      nameKey: "devotion.specimenStitch.name",
      effect: "preserve",
      targetType: "object",
      text: "夢1つの現在値を保存し、以後は深度が変わっても同じ値を保つ。反転や強弱操作は受ける。",
      textKey: "devotion.specimenStitch.text",
    },
  },
  {
    id: "compass",
    name: "《羅針盤》",
    nameKey: "servant.compass.name",
    title: "願いの向く先を示す者",
    titleKey: "servant.compass.title",
    art: "../../assets/story/chapters/chapter-01/characters/compass-standing-v1.png",
    artId: "servant.compass",
    devotion: {
      id: "show-the-course",
      name: "針路を示す",
      nameKey: "devotion.showTheCourse.name",
      effect: "guide",
      targetType: "object",
      text: "この時間、自分の注目は選んだ夢を追う。その夢から受ける影響を符号方向へ1強める。",
      textKey: "devotion.showTheCourse.text",
    },
  },
];

const servantMap = new Map(SERVANTS.map((servant) => [servant.id, servant]));
const devotionMap = new Map(SERVANTS.map((servant) => [servant.devotion.id, servant.devotion]));

export function getServant(servantId: string | undefined): ServantDefinition | null {
  return servantId ? servantMap.get(servantId) ?? null : null;
}

export function getDevotion(devotionId: string | undefined) {
  return devotionId ? devotionMap.get(devotionId) ?? null : null;
}
